import { render, staticRenderFns } from "./GamesButtons.vue?vue&type=template&id=090cbe34&scoped=true&lang=pug&"
import script from "./GamesButtons.vue?vue&type=script&lang=js&"
export * from "./GamesButtons.vue?vue&type=script&lang=js&"
import style0 from "./GamesButtons.vue?vue&type=style&index=0&id=090cbe34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090cbe34",
  null
  
)

export default component.exports